import { createSelector } from "reselect";
import _ from "lodash";
export const selectDailyWSReport = ({ DailyWorksheet_reducer }) => {
    return DailyWorksheet_reducer.report;
};
export const selectConfig = ({ MainReducer }) => {
    if (MainReducer.config) return MainReducer.config;
    else return false;
};
export const selectVehicles = ({ DailyWorksheet_reducer }) => {
    return DailyWorksheet_reducer.vehicles;
};
export const selectEquipment = ({ DailyWorksheet_reducer }) => {
    return DailyWorksheet_reducer.equipment;
};
export const selectUserNames = ({ MainReducer }) => {
    if (MainReducer.users) {
        return _.compact(
            Object.keys(MainReducer.users).map((e) => {
                const {
                    profile: {
                        first_name = "N/A",
                        last_name = "N/A",
                        deleted = false,
                    },
                } = MainReducer.users[e];
                if (deleted === false) return first_name + " " + last_name;
                return null;
            })
        ).sort();
    } else return false;
};

export const selectProfile = ({ UserProfile_reducer }) => {
    if (UserProfile_reducer.profile) return UserProfile_reducer.profile.profile;
    else return false;
};
export const selectPermissions = createSelector(
    [selectConfig, selectProfile],
    (config = false, { access_level = false }) => {
        if (access_level && config) {
            return config[access_level]["prowork_generic_daily_worksheet_v1"];
        } else return false;
    }
);

export const canUpdate = createSelector(
    [selectPermissions],
    (config = false) => {
        return config ? config.update : true;
    }
);
export const selectReport = createSelector([selectDailyWSReport], (report) => {
    if (report === false) {
        return false;
    }
    let Meters = 0,
        Sq_Meters = 0,
        Cu_Meters = 0,
        Items = 0,
        number = 0,
        Tonne = 0;

    if (report.job_lots) {
        report.job_lots.map((e) => {
            if (e.unit_metric === "Meters") {
                Meters = Meters + Number(e.unit_count);
            } else if (e.unit_metric === "Sq. Meters") {
                Sq_Meters = Sq_Meters + Number(e.unit_count);
            } else if (e.unit_metric === "Cu. Meters") {
                Cu_Meters = Cu_Meters + Number(e.unit_count);
            } else if (e.unit_metric === "Items") {
                Items = Items + Number(e.unit_count);
            } else if (e.unit_metric === "Number") {
                number = number + Number(e.unit_count);
            } else if (e.unit_metric === "Tonne") {
                Tonne = Tonne + Number(e.unit_count);
            } else {
            }

            return null;
        });
    }
    report.job_lots_summary = {
        Meters: Meters,
        "Sq. Meters": Sq_Meters,
        "Cu. Meters": Cu_Meters,
        Items: Items,
        Number: number,
        Tonne: Tonne,
    };
    return report;
});
